import Vue from "vue";
/**
 * @name bus注册
 * @description 为了实现兄弟组件或跨层级组件间传值
 * @author liuguisheng
 * @version 2019-9-20
*/
export const bus = new Vue();


// WEBPACK FOOTER //
// ./src/utils/bus.js